import { render, staticRenderFns } from "./configuration-local-accounting-billable-clients-grid.vue?vue&type=template&id=48cc5cd0&"
import script from "./configuration-local-accounting-billable-clients-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-accounting-billable-clients-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports